<template>
  <div align="center">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">{{ $t("inquiry") }}</a>
      <img src="../../assets/img/jt.gif" /> <span v-if="Search.AwbBlType=='S'"> {{ $t("sea") }} </span>
      <span v-if="Search.AwbBlType=='A'"> {{ $t("air") }}</span>

    </div>
    <div>
      <table-no-record v-if="JSON.stringify(entity.listTo)=='[]'"></table-no-record>
      <div v-if="JSON.stringify(entity.listTo)!='[]'">
        <div align="left" style="padding-left:  15px;">
          <template v-if="user.userCode!=''&& (user.userCode!='TTMTTAHKG' && user.userCode!='TTMTTAREX' && user.userCode!='AKMHKG' && user.userCode!='AKMREX'  ) ">
            <a class="btn btn-info" @click="exportExcel" target="_bank">{{ $t("export_excel") }}
              <span style="width:20px;"></span>
              <img src="../../assets/img/xlsx.svg" style="width:20px;text-align:right;">
            </a>
          </template>
          <template v-if="user.userCode!='' ">
            <span style="padding-left:5px;"></span>
            <a class="btn btn-info" target="_bank" @click="ExportTransitExcel">{{ $t("export_excel1") }}
              <span style="width:20px;"></span>
              <img src="../../assets/img/xlsx.svg" style="width:20px;text-align:right;">
            </a>
          </template>

          <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe">
            <tbody>
              <tr class="trtitle">
                <td width="6%" height="20" valign="middle"> {{ $t("anonymou_house_no") }} </td>
                <td width="4%" nowrap="true"> {{ $t("anonymou_orgn_code") }} </td>
                <td width="4%" nowrap="true">{{ $t("anonymou_dest_code") }} </td>
                <td width="10%">CNEE Name</td>
                <td width="4%" nowrap="true">Term</td>
                <td width="4%" nowrap="true" align="right"> {{ $t("anonymou_qty") }}</td>
                <td width="4%" nowrap="true" align="right"> {{ $t("anonymou_gw") }}</td>
                <td width="4%" nowrap="true" align="right"> {{ $t("anonymou_cw") }} </td>
                <td width="4%" nowrap="true"> {{ $t("normal_state_dates31") }} </td>
                <td width="4%" nowrap="true"> {{ $t("anonymou_state_dates33") }} </td>
                <td width="10%">
                  <p v-html=" $t('normal_detail') "></p>
                </td>
                <td width="20%"> {{ $t("normal_word5") }}</td>
              </tr>
              <tr v-for="(item,index) in entity.listTo" :key="index" class="tr1" onmouseover="this.className='shen'" onmouseout="this.className='tr1'">
                <td height="18" valign="middle">
                  <a @click="clickHouseNo(item)">{{item.house_No}}</a>
                </td>
                <td valign="middle">{{item.orgn_Code}}</td>
                <td valign="middle">{{item.dest_Code}}</td>
                <td>
                  <span v-if="lang=='en'">{{item.cnee_Ename}}</span>
                  <span v-if="lang=='zh-cn'">{{item.cnee_Cname}}</span>
                  <span v-if="lang=='zh-tw'">{{item.cnee_Cname}}</span>
                </td>
                <td valign="middle" nowrap="true">{{item.inco_Terms}} </td>
                <td valign="middle" nowrap="true" align="right">{{item.qty}} </td>
                <td valign="middle" nowrap="true" align="right">{{item.gw}} </td>
                <td valign="middle" nowrap="true" align="right">{{item.cw}} </td>
                <td valign="middle" nowrap="true">{{DateFmt(item.stateDates31)}} &nbsp; {{Time(item.stateTimes31)}}</td>
                <td valign="middle" nowrap="true">{{DateFmt(item.stateDates33)}} &nbsp; {{Time(item.stateTimes33)}}</td>
                <td valign="middle" nowrap="true">
                  <template v-if="Search.AwbBlType=='S'">
                    <span style="float:left;"><a @click="Container(item)">{{ $t("normal_word2") }} |</a></span>
                  </template>
                  <template v-if="user.userCode!='' && (user.userCode!='TTMTTAHKG' &&
                     user.userCode!='TTMTTAREX' &&
                     user.userCode!='AKMHKG' &&
                     user.userCode!='AKMREX' 
                     )">
                    <span style="float:left;"> <a @click="poinv(item)">{{ $t("normal_word3") }} |</a></span>
                  </template>
                  <span style="float:left;">
                    <house-no-attach-file :attach="getAttachFilesForHouseNo(item.house_No)" :houseNo="item.house_No"></house-no-attach-file>
                  </span>
                  <!-- <m:AttachFile house_no="${temp.house_no}" dept_no="AE"/> -->
                  <a @click="statecClick(item)"> {{ $t("normal_word5") }}</a>
                </td>
                <td>
                  <state-code :stateCode="item.state_Code" :stateCodeSource="stateCodeSource"></state-code>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
      <pagination v-if="JSON.stringify(entity.listTo)!='[]'" :total="entity.totalLength" @current-change="changePage" :pageSize="50" :current-page="entity.page"></pagination>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import HouseNoAttachFile from "@/components/infrastructure/layout/house-no-attach-file.vue";
import { GetUserAwbQueryList } from "@/api/UserAwbQuery.js";
import { getHouseNoAttachFiles } from "@/api/airwayBill.js";
import stateCode from "@/components/infrastructure/layout/state-code.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";
import { mapActions } from "vuex";
export default {
  name: "user-awb-query-list",
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
    HouseNoAttachFile,
    stateCode,
    TableNoRecord,
    Pagination,
  },
  data () {
    return {
      Search: {
        // AwbBlType: "A",
        // CodeType: "1",
        // EtaDate: "",
        // EtdDate: "",
        // FrtTerm: 0,
        // HouseNo: "",
        // PoNo: "",
        // InvNo: "",
        // DestCode: "",
        // OrgnCode: "",
        // Page: 1,
        // Row: 50,
      },
      user: {
        userCode: "",
      },
      entity: {
        listTo: [],
      },
      stateCodeSource: [],
      attachFiles: [],
      lang: ''
    };
  },
  async mounted () {
    this.Search = JSON.parse(this.$route.query.info);
    this.stateCodeList();
    this.query();
    this.stateCodeSource = await this.fetchStateCodeListAsync();
    this.lang = this.$store.getters.lang;
  },
  methods: {
    ...mapActions(["fetchStateCodeListAsync"]),
    async query () {
      var self = this;
      this.$loading.show();
      var res = await GetUserAwbQueryList(this.Search).getResponseAsync();
      if (res == null) {
        return;
      }

      if (res.data.listTo.length > 0) {
        var fileRes = await getHouseNoAttachFiles({
          houseNoList: res.data.listTo.map((c) => c.house_No),
        });
        if (fileRes != null) {
          self.attachFiles = fileRes.data;

        } else {
          self.attachFiles = [];
        }
      }
      window.scrollTo(0, 0);
      this.entity = res.data;
      this.$loading.close();
    },
    stateCodeList () {
      this.user = this.$store.getters.user;
      // console.log(this.user);
    },
    getAttachFilesForHouseNo (houseNo) {
      console.log("333");
      console.log(this.attachFiles)
      console.log(houseNo);
      console.log("mm");
      for (var i = 0; i < this.attachFiles.length; i++) {
        if (houseNo == this.attachFiles[i].houseNo) {
          return this.attachFiles[i].attachFiles;
        }
      }
      return [];
    },
    exportExcel () {
      this.Search.AwbBlType =
        this.Search.AwbBlType == null ? "" : this.Search.AwbBlType;
      this.Search.EtaDate =
        this.Search.EtaDate == null ? "" : this.Search.EtaDate;
      this.Search.EtdDate =
        this.Search.EtdDate == null ? "" : this.Search.EtdDate;
      this.Search.CodeType =
        this.Search.CodeType == null ? "" : this.Search.CodeType;
      this.Search.FrtTerm =
        this.Search.FrtTerm == null ? "" : this.Search.FrtTerm;
      this.Search.OrgnCode =
        this.Search.OrgnCode == null ? "" : this.Search.OrgnCode;
      this.Search.DestCode =
        this.Search.DestCode == null ? "" : this.Search.DestCode;

      this.Search.InvNo = this.Search.InvNo == null ? "" : this.Search.InvNo;
      this.Search.PoNo = this.Search.PoNo == null ? "" : this.Search.PoNo;
      this.Search.HouseNo =
        this.Search.HouseNo == null ? "" : this.Search.HouseNo;
      // console.log(this.apiUrl +
      // "UserAwbQuery/ExportExcel?AwbBlType="+this.Search.AwbBlType +
      // "&EtdDate=" + this.Search.EtdDate+
      // "&EtaDate"+this.Search.EtaDate+
      // "&CodeType"+this.Search.CodeType+
      // "&FrtTerm"+this.Search.FrtTerm+
      // "&OrgnCode"+this.Search.OrgnCode+
      // "&DestCode"+this.Search.DestCode+
      // "&InvNo"+this.Search.InvNo+
      // "&PoNo"+this.Search.PoNo+
      // "&HouseNo"+this.Search.HouseNo)
      this.$utils.downloadFile(
        this.apiUrl +
        "UserAwbQuery/ExportExcel?AwbBlType=" +
        this.Search.AwbBlType +
        "&EtdDate=" +
        this.Search.EtdDate +
        "&EtaDate=" +
        this.Search.EtaDate +
        "&CodeType=" +
        this.Search.CodeType +
        "&FrtTerm=" +
        this.Search.FrtTerm +
        "&OrgnCode=" +
        this.Search.OrgnCode +
        "&DestCode=" +
        this.Search.DestCode +
        "&InvNo=" +
        this.Search.InvNo +
        "&PoNo=" +
        this.Search.PoNo +
        "&HouseNo=" +
        this.Search.HouseNo,
        "GLS_TRACKING"
      );
    },
    clickHouseNo (item) {
      if (this.Search.AwbBlType == "A") {
        this.$router.push({
          name: "user-awb-query-no",
          query: {
            info: JSON.stringify({ item }),
            AwbBlType: this.Search.AwbBlType
          },
        });
      } else {
        this.$router.push({
          name: "user-awb-query-Seafreightno",
          query: {
            info: JSON.stringify({ item }),
            AwbBlType: this.Search.AwbBlType
          },
        });
      }

    },
    DateFmt (value) {
      if (value == "" || value == null) {
        return;
      }
      return (
        value.substr(0, 4) + "-" + value.substr(4, 2) + "-" + value.substr(6, 2)
      );
    },
    Time (value) {
      if (value == "" || value == null) {
        return;
      }

      return value.substr(0, 2) + ":" + value.substr(2, 2);
    },
    changePage (value) {
      this.Search.page = value;
      this.query();
    },
    poinv (item) {
      this.$router.push({
        name: "user-awb-query-poInv",
        query: {
          info: JSON.stringify({ item }),
          AwbBlType: this.Search.AwbBlType
        },
      });
    },
    statecClick (item) {
      // console.log(item);
      this.$router.push({
        name: "user-awb-query-state",
        query: {
          info: JSON.stringify({ item }),
          AwbBlType: this.Search.AwbBlType
        },
      });
    },
    Container (item) {
      // console.log(item);
      this.$router.push({
        name: "user-awb-query-container",
        query: {
          info: JSON.stringify({ item }),
          AwbBlType: this.Search.AwbBlType
        },
      });
    },
    ExportTransitExcel () {

      console.log(this.Search.HouseNo)
      // return 
      this.$utils.downloadFile(
        this.apiUrl +
        "UserAwbQuery/ExportTransitExcel?AwbBlType=" +
        this.Search.AwbBlType +
        "&EtdDate=" +
        this.Search.EtdDate +
        "&EtaDate=" +
        this.Search.EtaDate +
        "&CodeType=" +
        this.Search.CodeType +
        "&FrtTerm=" +
        this.Search.FrtTerm +
        "&OrgnCode=" +
        this.Search.OrgnCode +
        "&DestCode=" +
        this.Search.DestCode +
        "&InvNo=" +
        this.Search.InvNo +
        "&PoNo=" +
        this.Search.PoNo +
        "&HouseNo=" +
        this.Search.HouseNo,
        "Transit Time Report"
      );
    },
  },
  computed: {},
};
</script>